import React from "react";
import classNames from "classnames";

type PropsTypeProgress = {
  widthProgress?: string | number;
  colorProgressBar?: string | number;
  colorProgressValue?: string | number;
  progress: string | number;
  progressActive?: number;
};

function Progress({
  widthProgress,
  progress,
  colorProgressBar,
  colorProgressValue,
  progressActive,
}: PropsTypeProgress) {
  let progressPointMarginRule = "";
  if (progressActive && progressActive > 50) {
    progressPointMarginRule = `min(${progressActive}% - 5.5px, 100% - 13px)`;
  } else {
    progressPointMarginRule = `max(${progressActive}% - 5.5px, 2px)`;
  }

  return (
    <div
      className={classNames(
        colorProgressBar,
        widthProgress,
        "r-9 dark:bg-brd-dark-primary overflow-hidden rounded-sm bg-brd-primary",
      )}
    >
      <div
        className={classNames(
          colorProgressValue,
          "transition-width transition-min-width h-[15px] rounded-full pt-[2px] duration-300 ease-in-out",
        )}
        style={{ minWidth: progress ? "15px" : "0px", width: `${progress}%` }}
      >
        {progressActive !== 0 ? (
          <div
            className='h-[11px] w-[11px] rounded-full bg-white dark:bg-black'
            style={{
              marginLeft: progressPointMarginRule,
            }}
          />
        ) : null}
      </div>
    </div>
  );
}

export default Progress;
